import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InspectionTemplate, Order } from '@authority-labs/api-interfaces';
import { InspectionTypeEnum } from '@authority-labs/enums';
import { nameof } from '@authority-labs/helpers';
import { TableColumn } from '@check-list/app/classes';
import { CondOperator, QueryFilter } from '@nestjsx/crud-request';
import { InspectionTemplatesService } from '../inspection-templates.service';

@Component({
  selector: 'authority-labs-select-inspection-template-dialog',
  templateUrl: './select-inspection-template-dialog.component.html',
  styleUrls: ['./select-inspection-template-dialog.component.scss']
})
export class SelectInspectionTemplateDialogComponent implements OnInit {
  title = 'בחירת תבנית';
  selectedTemplate: InspectionTemplate;
  inspectionType: InspectionTypeEnum;
  isLoading: Record<number, boolean> = {};
  columns: TableColumn[] = [];
  filterParams: QueryFilter[];

  constructor(
    public dialogRef: MatDialogRef<Order>,
    @Inject(MAT_DIALOG_DATA)
    {
      inspectionType
    }: {
      inspectionType: InspectionTypeEnum;
    },
    public inspectionTemplatesService: InspectionTemplatesService,
    private datePipe: DatePipe
  ) {
    this.inspectionType = inspectionType;
    this.filterParams = [
      {
        field: nameof<InspectionTemplate>('inspectionType'),
        operator: CondOperator.EQUALS,
        value: inspectionType
      }
    ];
  }

  ngOnInit() {
    this.columns = [
      {
        prop: 'id',
        type: 'link',
        link: [],
        sortOrder: 'ascend',
        fieldType: 'number',
        width: '130px'
      },
      { prop: 'name' },
      { prop: 'description', width: '400px' },
      {
        prop: 'inspectionType',
        width: '200px',
        hideFilter: true,
        hideSort: true
      },
      {
        prop: 'createdAt',
        type: 'pipe',
        pipe: this.datePipe,
        fieldType: 'date'
      }
    ];
  }

  templateSelected(template: InspectionTemplate): void {
    this.selectedTemplate = template;
  }

  chooseAndClose(): void {
    this.dialogRef.close(this.selectedTemplate);
  }
}
